// The prototype's 24px line icons (dist/app.js `paths`), the platform marks and the channel palette (data.js).
export const PATHS = {
  panel: 'M3 4h18v16H3zM9 4v16', logo: 'M4 20V4h16M4 12h13M12 4v16',
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z', chart: 'M4 20V10m5 10V4m6 16v-7m5 7V7',
  target: 'M12 3a9 9 0 1 0 9 9M12 7a5 5 0 1 0 5 5M12 12l9-9M16 3h5v5',
  journey: 'M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4M18 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4M8 6h8a4 4 0 0 1 0 8H8a4 4 0 0 0 0 8h4',
  report: 'M6 3h9l4 4v14H6zM14 3v5h5M9 12h7M9 16h7', plug: 'M9 3v4m6-4v4M6 7h12v4a6 6 0 0 1-12 0zM12 17v4',
  settings: 'M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1zM15 12a3 3 0 1 0-6 0 3 3 0 0 0 6 0',
  help: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M9.5 9a2.5 2.5 0 1 1 4 2c-1.5 1-1.5 1-1.5 3M12 17h.01',
  search: 'M10.5 3a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M16 16l5 5', chevron: 'm8 10 4 4 4-4', right: 'm9 5 7 7-7 7', left: 'm15 5-7 7 7 7',
  arrow: 'M5 12h14m-5-5 5 5-5 5', arrowup: 'm6 16 10-10M6 6h10v10', download: 'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',
  calendar: 'M5 5h14v16H5zM8 3v4m8-4v4M5 10h14', compare: 'M3 7h15m-4-4 4 4-4 4M21 17H6m4-4-4 4 4 4', plus: 'M12 5v14M5 12h14',
  filter: 'M3 5h18l-7 8v6l-4 2v-8z', columns: 'M3 4h18v16H3zM9 4v16M15 4v16', sort: 'm8 3-4 4 4 4M4 7v14m12 0 4-4-4-4M20 17V3',
  bell: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4', info: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 10v6M12 7h.01',
  spark: 'm12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z', clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 7v5l4 2',
  check: 'm5 12 4 4L19 6', close: 'm6 6 12 12M6 18 18 6', more: 'M5 12h.01M12 12h.01M19 12h.01',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8M18 4a4 4 0 0 1 0 7M22 21v-2a4 4 0 0 0-3-4',
  refresh: 'M20 7v5h-5M4 17v-5h5M5 8a8 8 0 0 1 13-3l2 3M4 16l2 3a8 8 0 0 0 13-3', shield: 'M12 3 3 7v6c0 5 9 9 9 9s9-4 9-9V7zM8 12l3 3 5-6',
  mail: 'M3 5h18v14H3zM3 6l9 7 9-7', menu: 'M4 6h16M4 12h16M4 18h16', folder: 'M3 5h6l3 3h9v13H3z', copy: 'M9 9h12v12H9zM15 9V3H3v12h6',
  external: 'M14 3h7v7M21 3 10 14M10 3H3v18h18v-7', save: 'M4 3h13l4 4v14H4zM8 3v6h8V3M8 21v-8h9v8', code: 'm8 6-6 6 6 6m8-12 6 6-6 6',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M3 12h18M12 3c-5 5-5 13 0 18 5-5 5-13 0-18', bag: 'M5 7h14l2 14H3zM8 8V6a4 4 0 0 1 8 0v2',
  pause: 'M8 5v14M16 5v14', play: 'm8 4 12 8-12 8z', trash: 'M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14M10 11v6m4-6v6',
  zap: 'M13 2 4 14h7l-1 8 9-12h-7z', activity: 'M3 12h4l3-8 4 16 3-8h4', send: 'm3 11 18-8-8 18-2-8z',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6', eyeoff: 'm3 3 18 18M10 10a3 3 0 0 0 4 4M9.9 5.1A10 10 0 0 1 12 5c6 0 10 7 10 7a17 17 0 0 1-3.2 3.9M6.6 6.6A17 17 0 0 0 2 12s4 7 10 7a10 10 0 0 0 3.4-.6',
};

export function Logo({ className = '' }) {
  return (
    <svg className={`icon logo${className ? ` ${className}` : ''}`} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="5.6" cy="12" r="3.3" fill="currentColor" />
      <path d="M8.9 12h6.2" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" />
      <circle cx="18.2" cy="12" r="3.1" fill="#B5EC5E" stroke="currentColor" strokeWidth="2.1" />
    </svg>
  );
}

export function Icon({ name, small = false, className = '', ...rest }) {
  return (
    <svg className={`icon${small ? ' small' : ''}${className ? ` ${className}` : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}><path d={PATHS[name] || PATHS.grid} /></svg>
  );
}

// Which platform a source / channel / step belongs to — drives the square mark and the colour.
export function platformKey(name) {
  const n = String(name || '').toLowerCase();
  if (/meta|facebook|instagram|^fb$|fbclid/.test(n)) return 'meta';
  if (/google|gclid|youtube|adwords|gads/.test(n)) return 'google';
  if (/tiktok|ttclid/.test(n)) return 'tiktok';
  if (/linkedin|li_fat/.test(n)) return 'linkedin';
  if (/shopify/.test(n)) return 'shopify';
  if (/stripe|whop|ghl|gohighlevel|checkout|purchase|order|sale/.test(n)) return 'stripe';
  if (/klaviyo/.test(n)) return 'klaviyo';
  if (/email|mail|newsletter|activecampaign|mailchimp|convertkit|sms|st_e/.test(n)) return 'email';
  return 'direct';
}
export const CHANNEL_NAMES = { meta: 'Meta Ads', google: 'Google Ads', tiktok: 'TikTok Ads', linkedin: 'LinkedIn Ads', shopify: 'Shopify', stripe: 'Checkout', klaviyo: 'Klaviyo', email: 'Email', direct: 'Direct' };
export const CHANNEL_COLORS = { meta: '#4577e8', google: '#35a273', tiktok: '#ad70cc', linkedin: '#df9c49', shopify: '#82a347', stripe: '#7662d9', klaviyo: '#282825', email: '#67634e', direct: '#9a9f97' };
const EXTRA_COLORS = ['#4577e8', '#35a273', '#ad70cc', '#df9c49', '#82a347', '#7662d9', '#282825', '#67634e', '#9a9f97', '#5c8dda'];
export const channelName = name => CHANNEL_NAMES[platformKey(name)] || String(name || 'Direct');
export const channelColor = (name, index = 0) => (platformKey(name) === 'direct' && name && !/direct|\(none\)|none/i.test(name) ? EXTRA_COLORS[index % EXTRA_COLORS.length] : CHANNEL_COLORS[platformKey(name)]);

const CANONICAL = { meta: ['facebook', 'meta', 'fb', 'instagram', 'ig'], google: ['google', 'adwords', 'gads'], tiktok: ['tiktok'], linkedin: ['linkedin'] };
export function sourceLabel(raw) {
  const value = String(raw ?? '');
  if (!value || value === '(none)') return 'No ad signal';
  const key = platformKey(value);
  const canonical = CANONICAL[key];
  if (!canonical) return key === 'direct' ? value : `${CHANNEL_NAMES[key]} · ${value}`;
  return canonical.includes(value.toLowerCase()) ? CHANNEL_NAMES[key] : `${CHANNEL_NAMES[key]} · ${value}`;
}

const GLYPHS = { meta: '∞', google: 'G', tiktok: '♪', linkedin: 'in', shopify: 'S', stripe: 's', klaviyo: 'K' };
export function PlatformIcon({ name, title, className = '' }) {
  const key = platformKey(name);
  const label = title || channelName(name);
  return (
    <span className={`platform-icon ${key}${className ? ` ${className}` : ''}`} title={label} aria-label={label}>
      {GLYPHS[key] || <Icon name={key === 'email' ? 'mail' : 'globe'} />}
    </span>
  );
}
